import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface BackLinkProps {
  to: string;
  children: React.ReactNode;
  className?: string;
}

/**
 * The one way to go back a level.
 *
 * Points at a route rather than calling history.back(), so arriving from a
 * bookmark, an email or a refresh still lands somewhere sensible.
 *
 * Only the arrow moves on hover. Growing the box at the same time was tried
 * and reads as a wobble rather than as a direction.
 */
export function BackLink({ to, children, className }: BackLinkProps) {
  return (
    <Link
      to={to}
      className={cn(
        "group inline-flex items-center gap-2 font-medium text-primary transition-colors hover:text-primary/80",
        className,
      )}
    >
      <ArrowLeft className="h-4 w-4 transition-transform duration-200 group-hover:-translate-x-0.5" />
      {children}
    </Link>
  );
}

export default BackLink;
